import TextField from 'material-ui/TextField';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import withHandlers from 'recompose/withHandlers';
import withValue from '../with-value';

const enhance = compose(
	withHandlers({
		onChange: props => e => {
			const {
				name,
				valueChangeListener,
				setFieldValue
			} = props;

			setFieldValue(name, e.target.value);

			// don't sure about this
			if (valueChangeListener) {
				valueChangeListener(e);
			}
		},
		onBlur: props => () => {
			props.setFieldTouched(props.name, true);
		}
	}),
	mapProps(props => {
		const {
			setFieldValue, setFieldTouched, setFieldError,
			valueChangeListener, ...rest
		} = props;

		return rest;
	}),
	withValue
);

export default enhance(TextField);



// WEBPACK FOOTER //
// ./src/client/components/admin/common/form/text-field/index.js